<template>
  <LayoutBasic  :showLinksMenu="false" 
  
  
  >
    <!-- Título del drawer -->
    <template v-slot:title>
      <v-list-item @click="$router.push('/')" class="hoverable">
        <v-list-item-icon>
          <v-icon large>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="title font-weight-bold">Inicio</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>

    <!-- Encabezado principal -->
    <template v-slot:navigation-title>Empleados</template>

    <!-- Accesos laterales -->
    <template v-slot:navigation-after-links>
      <v-list dense nav >


        <!-- <v-list-item :to="{ name: 'empresa.empleados.asignar' }" class="hoverable">
          <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Asignar</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

      

       
      </v-list>
    </template>

    <!-- Contenido principal -->
    <template v-slot:vista-previa>
      <router-view />
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from '@/layouts/LayoutBasic.vue'

export default {
  name: 'ComprasEmpresaLayout',
  components: { LayoutBasic },
  computed: {
     
  },
}
</script>
